import { useQueryClient } from "@tanstack/react-query";
import $api from "./openapi";
import toast from "react-hot-toast";

export default function useUpdateShopSettings() {
  const queryClient = useQueryClient();
  const { mutate } = $api.useMutation("patch", "/api/teams/{team_slug}/shop", {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["get", "/api/teams/{team_slug}/shop"],
      });
    },
    onError: () => toast.error("Failed to update shop settings"),
  });
  return mutate;
}
